import ListItem from "@components/list-item";
import { Image } from "expo-image";
import * as React from "react";

import RadioIcon from "./icons/radio-icon";

function RadioButtonListItem({
  title,
  description,
  value,
  onChange,
  disabled,
  icon,
}: {
  title: string;
  description?: string;
  value: boolean;
  onChange: (v: boolean) => void;
  disabled?: boolean;
  icon?: { uri: string };
}) {
  return (
    <ListItem
      left={<RadioIcon checked={value} size={24} color="$primary" />}
      title={title}
      icon={icon ? <Image source={icon} style={{ width: 24, height: 24, borderRadius: 4 }} /> : undefined}
      description={description}
      onPress={() => onChange(!value)}
      maxNumberOfLines={3}
      disabled={disabled}
    />
  );
}
export default RadioButtonListItem;
